import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";





'use strict';





var helpers = {

  checkbox: function(data) {
    var requiredAttrs = ["id"],
      reservedAttrs = ["type","data-mask","data-gis-mask"],
      combinableAttrs = {"class": "spa-input-option spa-input-option--checkbox", "value": ""},
      attrsStr,
      checkboxString="",
      output;

    for(var i=0, len=data.checkboxes.length;i<len;i++) {
      var checkbox = data.checkboxes[i];
      if(!Handlebars.helpers.requiredAttrsCheck(checkbox.checkbox.attrs,requiredAttrs).pass) {

        throw new Error("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(checkbox.checkbox.attrs,requiredAttrs).missingField);


        if(window.console && console.log) {
          console.log("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(checkbox.checkbox.attrs,requiredAttrs).missingField);
          return "";
        }
      }
      Handlebars.helpers.removeReservedAttrs(checkbox.checkbox.attrs,reservedAttrs);
      Handlebars.helpers.combineAttrs(checkbox.checkbox.attrs,combinableAttrs);
      attrsStr = Handlebars.helpers.buildAttrsString(checkbox.checkbox.attrs);

      checkboxString +=
      '<li> \
        <input type="checkbox" '+attrsStr+' /> \
        <span class="spa-input-check">&nbsp;</span> \
        <label class="spa-input-option-label" for="'+checkbox.checkbox.attrs.id+'">'+checkbox.label.text+'<span class="ada-hidden"> '+((checkbox.label.adaText) ? checkbox.label.adaText : '')+'</span></label> \
      </li>';
    }

    output = '<div class="spa-input spa-input-options spa-input--'+((data.skin) ? data.skin : 'material-design')+' '+((data.containerClasses) ? data.containerClasses.join(' ') : '')+'">' +
              ((data.label) ? '<label class="spa-input-options-label">' + data.label + '</label>' : '') +
              '<ul class="spa-input-options-list">'
              +checkboxString+
              '</ul> \
              <p class="spa-input-options-hint">'+((data.hintText) ? data.hintText : '')+'</p> \
          </div>';

    return new Handlebars.SafeString(output);
  }
};



module.exports.register = function (Handlebars, options) {
  options = options || {};
  for (var helper in helpers) {
    if (helpers.hasOwnProperty(helper)) {
      Handlebars.registerHelper(helper, helpers[helper]);
    }
  }
};


module.exports.helpers = helpers;
